import type { Sensitivity } from '@aiassist/shared-types';
import { create } from 'zustand';

interface AppState {
  // User-tunable orchestrator sensitivity. Synced via the backend Sync API later.
  sensitivity: Sensitivity;
  setSensitivity: (s: Sensitivity) => void;

  // Active topic groups selected for the next observation session.
  activeTopicGroupIds: ReadonlyArray<string>;
  setActiveTopicGroupIds: (ids: ReadonlyArray<string>) => void;

  // UI state.
  sidebarOpen: boolean;
  setSidebarOpen: (v: boolean) => void;
}

export const useAppStore = create<AppState>((set) => ({
  sensitivity: 'balanced',
  setSensitivity: (sensitivity) => set({ sensitivity }),

  activeTopicGroupIds: [],
  setActiveTopicGroupIds: (activeTopicGroupIds) => set({ activeTopicGroupIds }),

  sidebarOpen: true,
  setSidebarOpen: (sidebarOpen) => set({ sidebarOpen }),
}));
